import { render, staticRenderFns } from "./NetaEventDetailsView.vue?vue&type=template&id=7967ac75&scoped=true&"
import script from "./NetaEventDetailsView.vue?vue&type=script&lang=js&"
export * from "./NetaEventDetailsView.vue?vue&type=script&lang=js&"
import style0 from "./NetaEventDetailsView.vue?vue&type=style&index=0&id=7967ac75&lang=scss&scoped=true&"
import style1 from "./NetaEventDetailsView.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7967ac75",
  null
  
)

export default component.exports